import { useCallback } from 'react'
import {
  getCachedContentCards,
  requestContentCardsRefresh,
  subscribeToContentCardsUpdates,
} from '@braze/web-sdk'
import { useBrazeStore } from './braze.store'
import { BaseBrazeCard } from './types'

export const useBrazeContentCardsSubscription = () => {
  const setBrazeState = useBrazeStore((state) => state.setBrazeState)

  const handleContentCardUpdate = useCallback(() => {
    try {
      const cached = getCachedContentCards()

      if (cached.lastUpdated) {
        const cards = getCachedContentCards().cards as BaseBrazeCard[]
        setBrazeState({ cards, isError: false, isLoading: false })
      }

      requestContentCardsRefresh()
    } catch (e) {
      console.error('Braze: Failed to get cached cards.', e)
      setBrazeState({ isError: true })
    }
  }, [setBrazeState])

  const subscribeToContentCards = useCallback(() => {
    return subscribeToContentCardsUpdates(handleContentCardUpdate)
  }, [handleContentCardUpdate])

  return {
    subscribeToContentCards,
    handleContentCardUpdate,
  }
}
